import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import projectsStyle from './Projects.module.scss';
import ProjectCard from '../../components/projectCard/ProjectCard';
import SectionHeading from '../../components/elements/sectionHeading/SectionHeading';
import Reveal from '../../components/elements/reveal/Reveal';
import Contact from '../../components/sections/contact/Contact';
import { projects } from '../../data/projects';

const Projects = observer(() => {
    const { t } = useTranslation();

    return (
        <>
            <section className={projectsStyle.section}>
                <div className={projectsStyle.inner}>
                    <SectionHeading eyebrow={t('projects.eyebrow')} title={t('projects.title')} description={t('projects.description')} />

                    <div className={projectsStyle.grid}>
                        {projects?.map((project, i) => (
                            <Reveal key={project.name} delay={i * 80} className={projectsStyle.cell}>
                                <ProjectCard project={project} />
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            <Contact />
        </>
    );
});

export default Projects;
